import { BasicFilterSelectField } from 'lib/iterable-hook-form/FormField/BasicFilterSelectField';
import { CREATE_GOAL_FORM_TEST_IDS, EVENT_NAME_FIELD } from './CreateGoalForm.constants';
import { useCombinedEventOptions } from './hooks/useCombinedEventOptions';

export const EventField = () => {
  const { options } = useCombinedEventOptions();

  return (
    <BasicFilterSelectField
      id={CREATE_GOAL_FORM_TEST_IDS.EVENT}
      name={EVENT_NAME_FIELD}
      placeholder={'Select an event to add to your goal'}
      options={options}
      data-test={CREATE_GOAL_FORM_TEST_IDS.EVENT}
      isDisabled={false}
      isFullWidth={true}
    />
  );
};
